/* eslint-disable @typescript-eslint/no-explicit-any */
const initialState: any = {
  data: null
};

export default initialState;
